<template>
  <content-layout :title="title" :headImage="headImage" :tabs="tabs" v-model="activeTab">
    <div class="icons" slot="icons">
      <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div class="activity-item mgui-container" slot="/department">
      <loading :visible="false"></loading>
      <organiz-tree :nodes="nodeData" class="organiz-tree-one" :parentExpand="true" @onExpand="onExpand" @onAdd="onAdd" @onEdit="onEdit" @onDel="onDel"></organiz-tree>
    </div>
    <div class="activity-item mgui-container" slot="form">
      <div v-if="viewPower" style="padding:40px;text-align:center">
        您没有查看权限，请联系管理员
      </div>
      <Spin v-if="spinShow" fix>
          <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
          <div>Loading</div>
      </Spin>
      <Form ref="menusForm" :model="formItem" label-position="top" :rules="ruleInline">
        <FormItem label="上级">
          <Select v-model="formItem.pid" clearable style="width:200px">
              <Option :value="0" :key="0">顶级</Option>
              <Option v-for="item in nodeData" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem label="名称" prop="title">
          <Input v-model="formItem.title" placeholder="请输入名称"></Input>
        </FormItem>
        <FormItem label="标识" prop="name">
          <Input v-model="formItem.name" placeholder="请输入英文标识"></Input>
        </FormItem>
        <FormItem label="URL" prop="url">
          <Input v-model="formItem.url" placeholder="请输入URL"></Input>
        </FormItem>
        <FormItem label="状态">
          <Switch v-model="formItem.status" size="large">
              <span slot="open">启用</span>
              <span slot="close">禁用</span>
          </Switch>
        </FormItem>
        <FormItem label="">
          <Button type="primary" @click="submitMenus('menusForm')">提交</Button>
          <Button type="default" @click="clearForm">取消</Button>
        </FormItem>
      </Form>
    </div>
  </content-layout>
</template>


<script>
  import {fetch, post, del} from '../fetch/api'
  const formData = {
    'id': 0,
    'pid': 0,
    'title': null,
    'name': null,
    'url': null,
    'status': true
  }
  export default {
    name: 'ActivityMoneys',
    components: {
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) },
      OrganizTree: resolve => { require(['../components/OrganizTreeComponent'], resolve) },
      Loading: resolve => { require(['../components/LoadingComponent'], resolve) }
    },
    data () {
      return {
        title: '组织架构',
        headImage: '/static/images/bg/money.jpeg',
        tabs: [
          {'title': '组织架构', 'key': '/department', 'visible': true}
        ],
        spinShow: true,
        activeTab: '/department',
        nodeData: [],
        treeValue: null,
        viewPower: false,
        expandIds: [],
        formItem: JSON.parse(JSON.stringify(formData)),
        ruleInline: {
          title: [
            {required: true, message: '请输入名称', trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入标识', trigger: 'blur'}
          ],
          url: [
            {required: true, message: '请输入URL', trigger: 'blur'}
          ]
        }
      }
    },
    watch: {
      activeTab () {
        // console.log(val)
      }
    },
    mounted () {
      this.fetchData()
      setTimeout(() => {
        this.viewPower = this.$menu.isPower('structure', 'view')
      }, 400)
    },
    methods: {
      fetchData () {
        fetch('console/department/0').then(res => {
          this.nodeData = res
          this.spinShow = false
        })
      },
      submitMenus (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let data = this.formItem
            post(`/console/menu`, data)
            .then(res => {
              if (res.status === 'ok') {
                this.$Message.success(data.id === 0 ? '添加成功' : '编辑成功')
                this.formItem = JSON.parse(JSON.stringify(formData))
                if (data.id > 0) {
                  this.activeTab = 'lists'
                }
                this.fetchData()
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 5
                })
              }
            })
            .catch(res => {
              this.$Message.error(res.msg)
            })
          } else {
            this.$Message.error('请确认表单是否填写完整')
          }
        })
      },
      editForm (data) {
        this.formItem = {
          'id': data.node.id,
          'pid': data.node.pid,
          'title': data.node.title,
          'name': data.node.name,
          'url': data.node.url,
          'status': data.node.status === 1
        }
        this.activeTab = 'form'
      },
      remove (root, node, data) {
        del(`/console/menu/${data.id}`).then(res => {
          if (res.status === 'ok') {
            this.$Message.success('删除成功')
            if (this.nodeData.indexOf(data) >= 0) {
              let index = this.nodeData.indexOf(data)
              this.nodeData.splice(index, 1)
            } else {
              const parentKey = root.find(el => el === node).parent
              const parent = root.find(el => el.nodeKey === parentKey).node
              let index = parent.children.indexOf(data)
              parent.children.splice(index, 1)
            }
          }
        })
      },
      clearForm () {
        this.activeTab = 'lists'
        this.formItem = JSON.parse(JSON.stringify(formData))
      },
      onEdit (node) {
        this.treeValue = node.name
        this.$Modal.confirm({
          title: '编辑',
          render: (h) => {
            return h('Input', {
              style: {
                marginTop: '10px',
                marginBottom: '-20px'
              },
              props: {
                value: this.treeValue,
                autofocus: true,
                placeholder: '请输入名称'
              },
              on: {
                input: (val) => {
                  this.treeValue = val
                }
              }
            })
          },
          onOk: () => {
            if (this.treeValue === null) return
            this.putNode({'name': this.treeValue, 'id': node.id})
          }
        })
        // post('console/department', {'name': this.treeValue, 'pid': node.id, 'id': 0})
        // .then((res) => {
        //   console.log(res)
        // })
      },
      onAdd (node) {
        this.$Modal.confirm({
          title: '添加',
          render: (h) => {
            return h('Input', {
              style: {
                marginTop: '10px',
                marginBottom: '-20px'
              },
              props: {
                value: '',
                autofocus: true,
                placeholder: '请输入名称'
              },
              on: {
                input: (val) => {
                  this.treeValue = val
                }
              }
            })
          },
          onOk: () => {
            if (this.treeValue === null) return
            // this.updateNode(this.nodeData, node)
            // 更新到服务器
            this.putNode({'name': this.treeValue, 'pid': node.id, 'id': 0})
          }
        })
      },
      onDel (node) {
        this.delNode(node.id)
      },
      onExpand (node) {
        this.expandNode(this.nodeData, node)
      },
      expandNode (nodes, node) {
        let k = nodes.indexOf(node)
        if (k >= 0) {
          // nodes[k].expand = !nodes[k].expand
          // console.log(nodes[k])
          this.$set(nodes[k], 'expand', !nodes[k].expand)
          return
        }
        for (let k in nodes) {
          if (nodes[k].children.length > 0) this.expandNode(nodes[k].children, node)
        }
      },
      putNode (data) {
        post('console/department', data)
          .then(() => {
            this.treeValue = null
            this.fetchData()
          })
      },
      delNode (id) {
        del(`console/department/${id}`)
          .then(() => {
            this.fetchData()
          })
      },
      updateNode (nodes, node) {
        for (let k in nodes) {
          if (nodes[k].id === node.id) {
            let children = nodes[k].children || []
            children.push({
              id: Number(node.id + '1'),
              pid: node.id,
              name: this.treeValue,
              children: []
            })
            this.$set(nodes[k], 'children', children)
            break
          } else {
            this.updateNode(nodes[k].children, node)
          }
        }
      }
    }
  }
</script>

<style proped>
  .organiz-tree-one{
    width: 100%;
    overflow: auto;
  }
</style>
